import InfoClinique from '@/views/parametres/configs/info-clinique'
import ParamPersonnel from '@/views/parametres/configs/param-personnels'
import ParamConsultation from '@/views/parametres/configs/param-consultations'
import ParamExamen from '@/views/parametres/configs/param-examens'
import ParamBon from '@/views/parametres/configs/param-bon-consultations'
import ParamChirurgie from '@/views/parametres/configs/param-chirurgies'
import BilanSante from '@/views/parametres/configs/param-bilan-sante'
import ParamSFE from '@/views/parametres/configs/param-sfe'
import ParamFicheMedicale from '@/views/parametres/configs/param-fiche-medical'
import ParamDevise from '@/views/parametres/configs/param-devise'
import ParamGestionCoupon from '@/views/parametres/configs/param-autorisation-coupons'
import ParamDHIS2 from '@/views/parametres/configs/param-dhis2'
import ParamAntecedents from '@/views/parametres/configs/param-antecedents'
import ParamModeleExamen from '@/views/parametres/configs/param-modele-examen'
import ParamSagefemme from '@/views/parametres/configs/param-sagefemme'
import ParamPrinter from '@/views/parametres/configs/param-printer'

import $ from 'jquery'

export default {
    name: 'configs',
    components: {
        InfoClinique, ParamPersonnel, ParamConsultation, 
        ParamExamen, ParamBon, ParamChirurgie, BilanSante,
        ParamSFE, ParamFicheMedicale,
        ParamDevise, ParamGestionCoupon, ParamDHIS2,
        ParamAntecedents, ParamModeleExamen, ParamSagefemme,
        ParamPrinter
    },
    props: [],
    data() {
        return {
            config_to_show: 4,

            tarif_filter: [
				{
                    libelle: 'Tous',
                    id: '0',
                },
                {
                    libelle: 'Consultations',
                    id: '1',
                },
                {
                    libelle: 'Analyses',
                    id: '2',
                },
				{
                    libelle: 'Examens',
                    id: '3',
                }
            ],
            filtre_tarif: '',
            can_print_info: false,
            info_clinique: {},
            img_url: '',
            print_toggler: 0,
            print_data: {}
        }
    },

    computed: {
        activeRole() {
            return this.$store.getters['activeRole'];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },

    mounted() {
        setTimeout(() => {
            $('.show-on-fixed').fadeIn();
        }, 500);
    },

    methods: {
        changeTab(tabindex) {
            this.config_to_show = tabindex
        },

        setInfoClinique(info_clinique) {
            console.log(">>> inf: ",info_clinique);
            
            this.info_clinique = info_clinique
            this.img_url = this.info_clinique.entete

            this.can_print_info = true
            setTimeout(() => {
                window.print()

                this.can_print_info = false
            }, 500);
        },

        printTrigger(data) {
            this.print_data = {}
            this.print_toggler = (this.print_toggler == 0)?1:0
            this.print_data = data
        }
    }
}